<template>
  <div class="info">
    <nav-title
      @refresh="getData"
    />
    <el-table
      v-loading="loading"
      :data="listData"
      border
      style="width: 100%"
      :header-cell-style="{
        background:'#D9E1E7',
        color:'#000'
      }"
      align="center"
    >
      <el-table-column
        label="序号"
        width="50"
        align="center"
      >
        <template scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="tradeOrgName"
        label="交易中心"
        align="center"
      />
      <el-table-column
        prop="linkMan"
        label="场地联系人"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="linkPhone"
        label="联系方式"
        align="center"
      />
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="openDefend(scope.row)">维护</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div>
      <pagination
        class="limit"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getData"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      listData: [],
      listQuery: {
        page: 1,
        limit: 10
      },
      total: 0
    }
  },
  activated() {
    this.listQuery = this.$options.data.call(this).listQuery
    this.getData()
  },
  methods: {
    // 获取列表数据
    getData() {
      this.loading = true
      const supperAdmin = this.$store.state.user.userinfo.supperAdmin
      this.$http.post(`/configs/sysevalroommanages/list`, {
        page: this.listQuery.page,
        rows: this.listQuery.limit,
        filter: {
          tradeOrgId: supperAdmin ? '' : this.$store.state.user.userinfo.orgInfo.orgId
        }
      }).then(res => {
        this.loading = false
        if (res.data.code) {
          this.$message.error(res.data.msg)
          return
        }
        const { data } = res
        this.listData = data.rows || []
        this.total = data.total || 0
      })
    },
    openDefend(row) {
      this.$router.push({
        path: '/field/info-maintain/index'
      })
      sessionStorage.setItem('row', JSON.stringify(row))
    }
  }
}
</script>
<style lang="less" scoped>
.info{
  margin-top:78px;
  padding:32px;
}
</style>
